import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Mark, Xp } from '../../../../Component/Layouts/Web/Student/WebUi';
import { useWeb } from '../../../../Component/Layouts/Web/Student/WebContext';
import { WEB_BASE } from '../../../../Component/Layouts/Web/Student/WebLayout';

const Home = () => {
  const navigate = useNavigate();
  const { xp, challengeDone, startChallenge } = useWeb();
  const progress = xp >= 1290 ? 80 : 72;

  return (
    <>
      <div className="web-h">
        <div>
          <h1>Hi, Aditi!</h1>
          <p>Keep going. Your journey builds a brighter future.</p>
        </div>
        <div className="web-card web-row">
          <Icon name="flame" />
          <b>7 day streak</b>
        </div>
      </div>

      <div className="web-grid two" style={{ marginBottom: 16 }}>
        <div className="web-card web-row">
          <span className="web-av" style={{ width: 64, height: 64 }}>AS</span>
          <div className="web-grow">
            <b>Level 7 · Explorer</b>
            <div className="web-xp"><Icon name="star" /> {xp.toLocaleString()} XP</div>
            <div className="web-bar"><i style={{ width: `${progress}%` }} /></div>
            <div className="web-mut">{progress}% to Level 8</div>
          </div>
        </div>
        <div className="web-card web-row">
          <Mark name="zap" from="#f59e0b" to="#f97316" />
          <div className="web-grow">
            <b>Today&apos;s challenge</b>
            <div className="web-mut">Finish a 10-minute lesson</div>
            <Xp amount={50} />
          </div>
          {challengeDone ? <b style={{ color: '#10a56b' }}>Done</b> : (
            <button type="button" className="web-btn" onClick={startChallenge}>Start</button>
          )}
        </div>
      </div>

      <div className="web-grid three" style={{ marginBottom: 16 }}>
        <button type="button" className="web-tile" style={{ background: 'linear-gradient(135deg,#2563eb,#4f46e5)' }} onClick={() => navigate(`${WEB_BASE}/course`)}>
          <Icon name="learn" />Learn<small>Courses & certs</small>
        </button>
        <button type="button" className="web-tile" style={{ background: 'linear-gradient(135deg,#8b5cf6,#6d28d9)' }} onClick={() => navigate(`${WEB_BASE}/job`)}>
          <Icon name="job" />Career<small>Jobs & internships</small>
        </button>
        <button type="button" className="web-tile" style={{ background: 'linear-gradient(135deg,#10b981,#059669)' }} onClick={() => navigate(`${WEB_BASE}/club`)}>
          <Icon name="users" />Campus Life<small>Clubs & events</small>
        </button>
      </div>

      <div className="web-grid two">
        <div className="web-card">
          <b>Your goals</b>
          <div className="web-row" style={{ marginTop: 14 }}>
            <Mark name="target" from="#8b5cf6" to="#ec4899" />
            <div className="web-grow">
              <div>Complete 2 courses this month</div>
              <div className="web-bar"><i style={{ width: '50%' }} /></div>
            </div>
            <span className="web-mut">1/2</span>
          </div>
          <div className="web-row" style={{ marginTop: 16 }}>
            <Mark name="mega" from="#8b5cf6" to="#ec4899" />
            <div className="web-grow">
              <b>Continue learning</b>
              <div className="web-mut">Digital Marketing · Module 4: Social Media Strategy</div>
              <div className="web-bar"><i style={{ width: '70%' }} /></div>
            </div>
            <button type="button" className="web-btn" onClick={() => navigate(`${WEB_BASE}/course`)}>Continue</button>
          </div>
        </div>
        <button type="button" className="web-card web-row" style={{ textAlign: 'left', cursor: 'pointer' }} onClick={() => navigate(`${WEB_BASE}/achievement`)}>
          <Mark name="trophy" from="#fbbf24" to="#f97316" />
          <div className="web-grow">
            <div className="web-mut">Latest achievement</div>
            <b>Won 2nd Prize – Inter-College Hackathon</b>
            <Xp amount={150} />
          </div>
          <Icon name="next" />
        </button>
      </div>
    </>
  );
};

export default Home;
